import { defineMessages } from 'react-intl';

const namespace = 'repvisits.overview.';

const messages = defineMessages({
  overviewNoResults: {
    id: `${namespace}overviewNoResults`,
    defaultMessage: 'You don\'t have any visits or fairs for the next week.',
  },
  makeAppointments: {
    id: `${namespace}makeAppointments`,
    defaultMessage: 'You can always make appointments by using the {searchAndScheduleLink} tool.',
  },
  searchAndSchedule: {
    id: `${namespace}searchAndSchedule`,
    defaultMessage: 'Search and Schedule',
  },
  yourUpcomingAppointments: {
    id: `${namespace}yourUpcomingAppointments`,
    defaultMessage: 'Your Upcoming Visits & Fairs',
  },
  details: {
    id: `${namespace}details`,
    defaultMessage: 'Details',
  },
  today: {
    id: `${namespace}today`,
    defaultMessage: 'Today',
  },
  tomorrow: {
    id: `${namespace}tomorrow`,
    defaultMessage: 'Tomorrow',
  },
  inPerson: {
    id: `${namespace}inPerson`,
    defaultMessage: 'In-person {type}',
  },
  virtual: {
    id: `${namespace}virtual`,
    defaultMessage: 'Virtual {type}',
  },
});

export default messages;
